var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTidalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_51604"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x38_69873"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665.8,334.2l-165.8,165.8-165.8-165.8,165.8-165.7,165.8,165.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x37_56993"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665.8,665.8l-165.8,165.8-165.8-165.8,165.8-165.8,165.8,165.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x38_7521"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.2,334.2l-165.8,165.8L2.7,334.2l165.8-165.8,165.8,165.8h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x35_49218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M997.3,334.2l-165.8,165.8-165.8-165.8,165.8-165.8,165.8,165.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidalLogo);
export default __webpack_public_path__ + "static/media/tidalLogo.866510794ad8e3fb6ad186f1b36f4c13.svg";
export { ForwardRef as ReactComponent };